import { Component, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { HttpService } from '@core/services/http.service';
import { forkJoin, Subject } from 'rxjs';
import { ModalDismissReasons, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationService } from '../registration.service';
import { ModalComponent } from '@app/shared/custom-component/modal/modal.component';
import { modalButtonTitles, ModalConfig, modalContent, modalHeading } from '@app/shared/constants/modal.model';
import { MatDialog } from '@angular/material/dialog';
import { ContentManagementModalComponent } from '@app/systemconfiguration/content-management/modal/content-management-modal.component';
import { finalize, take, takeUntil } from 'rxjs/operators';
import { LocalService } from '@app/@core/services/local.service';
import { AlertService } from '@app/@core/services/alert.service';
import { Password } from 'primeng/password';

@Component({
  standalone: false,
  selector: 'app-lea-registration',
  templateUrl: './lea-registration.component.html',
  styleUrls: ['./lea-registration.component.scss']
})
export class LEARegistrationComponent implements OnInit {

    customModal: NgbModalRef;

   onFirstNameInput(event: any) {
    let value = event.target.value;
    value = value.replace(/[^A-Za-z\-' ]/g, '');
    value = value.substring(0, 30);
    value = this.preventBackToBackChars(value);
    this.leaRegistrationForm.get('firstName')?.setValue(this.toTitleCase(this.normalizeSpaces(value)), { emitEvent: false });
  }

  onLastNameInput(event: any) {
    let value = event.target.value;
    value = value.replace(/[^A-Za-z\-' ]/g, '');
    value = value.substring(0, 30);
    value = this.preventBackToBackChars(value);
    this.leaRegistrationForm.get('lastName')?.setValue(this.toTitleCase(this.normalizeSpaces(value)), { emitEvent: false });
  }

  private toTitleCase(text: string): string {
    if (!text) return '';
    return text.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
  }

  // onOrganizationInput(event: any) {
  //   let value = event.target.value;
  //   value = value.substring(0, 60);
  //   // Basic character filtering only
  //   value = value.replace(/[^A-Za-z\s\.\,\-\&\'\(\)\/]/g, '');
  //   // Prevent leading spaces and back-to-back characters
  //   value = this.preventBackToBackChars(value);
  //   this.leaRegistrationForm.get('organization')?.setValue(value, { emitEvent: false });
  //   // Check for special character at end
  //   this.checkForSpecialCharAtEnd('organization');
  // }

  ondepartmentInput(event: any) {
    let value = event.target.value;
    value = value.substring(0, 60);
    // Basic character filtering only
    value = value.replace(/[^A-Za-z\s\.\,\-\&\'\(\)\/]/g, '');
    // Prevent leading spaces and back-to-back characters
    value = this.preventBackToBackChars(value);
    this.leaRegistrationForm.get('department')?.setValue(value, { emitEvent: false });
    // Check for special character at end
    this.checkForSpecialCharAtEnd('department');
  }

  onTitleInput(event: any) {
    let value = event.target.value;
    value = value.substring(0, 60);
    // Basic character filtering only
    value = value.replace(/[^A-Za-z\s\.\,\-\&\'\(\)\/]/g, '');
    // Prevent leading spaces and back-to-back characters
    value = this.preventBackToBackChars(value);
    this.leaRegistrationForm.get('title')?.setValue(value, { emitEvent: false });
    // Check for special character at end
    this.checkForSpecialCharAtEnd('title');
  }

onStreetAddressInput(event: any) {
  let value = event.target.value;
  // Allow A-Z, a-z, 0-9, space, period, comma, hyphen, apostrophe, number sign, forward slash
  value = value.replace(/[^A-Za-z0-9\s\.\,\-\'\#\/]/g, '');
  value = value.substring(0, 60);
  // Prevent leading spaces and back-to-back characters
  value = this.preventBackToBackChars(value);
  this.leaRegistrationForm.get('streetAddress')?.setValue(value, { emitEvent: false });
  // Check for special character at end
  this.checkForSpecialCharAtEnd('streetAddress');
}

onExtensionInput(event: any) {
  let value = event.target.value;
  // Only allow numbers
  value = value.replace(/[^0-9]/g, '');
  // Limit to 10 digits
  value = value.substring(0, 10);
  this.leaRegistrationForm.get('extension')?.setValue(value, { emitEvent: false });
}

  // Clean up fields when user leaves them (blur event)
  onFieldBlur(event: any, controlName: string) {
    let value = event.target.value;
    // Only trim spaces - allow all permitted special characters at start and end
    value = value.trim();
    // No longer remove special characters from start/end since they are allowed per requirements
    // All these characters are permitted: . , - & ' ( ) /
    // For street address: . , - ' # / are also allowed
    this.leaRegistrationForm.get(controlName)?.setValue(value, { emitEvent: false });

    // Check for special characters at the end of field
    this.checkForSpecialCharAtEnd(controlName);
  }

  checkForSpecialCharAtEnd(controlName: string) {
    const fieldsToCheck = [ 'title', 'department', 'streetAddress'];
    if (!fieldsToCheck.includes(controlName)) return;

    const value = this.leaRegistrationForm.get(controlName)?.value;
    if (!value) return;

    // Define special characters based on field type
    let specialCharsPattern;
    if (controlName === 'streetAddress') {
      specialCharsPattern = /[.,\-'#\/]$/; // For street address
    } else {
      specialCharsPattern = /[.,\-&'()\/]$/; // For organization, title, department
    }

    // Check if the field ends with a special character
    const endsWithSpecialChar = specialCharsPattern.test(value);

    if (endsWithSpecialChar) {
      this.leaRegistrationForm.get(controlName)?.setErrors({
        ...this.leaRegistrationForm.get(controlName)?.errors,
        specialCharAtEnd: true
      });
    } else {
      // Remove the special character error if it exists
      const errors = this.leaRegistrationForm.get(controlName)?.errors;
      if (errors && errors['specialCharAtEnd']) {
        delete errors['specialCharAtEnd'];
        if (Object.keys(errors).length === 0) {
          this.leaRegistrationForm.get(controlName)?.setErrors(null);
        } else {
          this.leaRegistrationForm.get(controlName)?.setErrors(errors);
        }
      }
    }
  }

  normalizeSpaces(value: string) {
  value = value.replace(/\s+/g, ' ');
  return value;
}

preventLeadingSpaces(value: string): string {
  // Remove leading spaces but allow spaces between characters
  value = value.replace(/^\s+/, '');
  // Replace multiple spaces with single space
  value = value.replace(/\s+/g, ' ');
  // Prevent back-to-back punctuations (.,&'()-/)
  value = value.replace(/[.,&'()\/\-]{2,}/g, (match) => match[0]);
  // Prevent back-to-back apostrophes specifically
  value = value.replace(/'{2,}/g, "'");
  return value;
}

preventBackToBackChars(value: string): string {
  // Remove leading spaces
  value = value.replace(/^\s+/, '');
  // Replace multiple consecutive spaces with single space
  value = value.replace(/\s{2,}/g, ' ');
  // Prevent back-to-back punctuations: period, comma, hyphen, ampersand, parentheses, forward slash, number sign
  value = value.replace(/[.]{2,}/g, '.');
  value = value.replace(/[,]{2,}/g, ',');
  value = value.replace(/[-]{2,}/g, '-');
  value = value.replace(/[&]{2,}/g, '&');
  value = value.replace(/[']{2,}/g, "'");
  value = value.replace(/[\(]{2,}/g, '(');
  value = value.replace(/[\)]{2,}/g, ')');
  value = value.replace(/[\/]{2,}/g, '/');
  value = value.replace(/[#]{2,}/g, '#');

  // Prevent mixed back-to-back punctuations
  // First handle same-character repetition
  value = value.replace(/([.,\-&'()\/#])\1+/g, '$1');

  // Then handle different consecutive special characters using a while loop
  // This will continue replacing until no more back-to-back punctuations exist
  while (/[.,\-&'()\/#][.,\-&'()\/#]/.test(value)) {
    value = value.replace(/([.,\-&'()\/#])([.,\-&'()\/#])/, '$1');
  }

  return value;
}


checkForTrailingSpace(event: any, controlName: string) {
  let value = event.target.value;
  this.leaRegistrationForm.get(controlName)?.setValue(value.trimEnd(), { emitEvent: false });
}



validateSpecialCharsAtEdges(value: string): string {
  // First replace multiple spaces with single spaces
  value = value.replace(/\s+/g, ' ');
  // Then trim any leading/trailing spaces
  value = value.trim();
  // Remove punctuation and apostrophes from beginning
  value = value.replace(/^[.,\/#!$%\^&\*;:{}=\-_`~()']+/, '');
  // Remove punctuation and apostrophes from end
  value = value.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()']+$/, '');
  return value;
}

validateGeneralTextbox(value: string): string {
  // Allow A-Z, a-z, space, period, comma, hyphen, ampersand, apostrophe, parentheses, forward slash
  value = value.replace(/[^A-Za-z\s\.\,\-\&\'\(\)\/]/g, '');
  // Prevent consecutive spaces
  value = value.replace(/\s+/g, ' ');
  // Prevent back-to-back punctuations (but allow while typing)
  value = value.replace(/[.,\-&'()\/]{3,}/g, (match) => match.substring(0, 2));
  return value;
}


  leaRegistrationForm: FormGroup;
  districtList: any[] = [];
  errorMessages: any[] = [];
  toastMessages: any[] = [];
  genericMessages: any[] = [];
  placeholderMessages: any[] = [];
  userAgreementContent: string = '';
  modalRef: NgbModalRef;
  closeResult = '';
  currentDate: string = new Date().toISOString().split('T')[0];
  errorMessage: any = {};
  toastMessage: any = {};
  genericMessage: any = {};
  placeholderMessage: any = {};
  showModal: boolean = false;
  private destroy$ = new Subject<void>();
  emailFromUrl: string = '';
  private userDistricts: string[] = [];

    constructor(
      private readonly fb: FormBuilder,
      private readonly router: Router,
      private readonly httpService: HttpService,
      private readonly ngModal: NgbModal,
      private readonly localstorage: LocalService,
      private readonly registrationService: RegistrationService,
      private readonly route: ActivatedRoute,
      private alertService: AlertService,
      private readonly matDialog: MatDialog
    ) {}


ngOnInit(): void {
  this.route.queryParams
    .pipe(takeUntil(this.destroy$))
    .subscribe(params => {
      this.emailFromUrl = params['email'] || '';
      this.createForm();
      if (this.emailFromUrl) {
        this.registrationService.getUserDetailsByEmail(this.emailFromUrl)
          .pipe(takeUntil(this.destroy$))
          .subscribe((user: any) => {
            if (user?.data?.data) {
              this.leaRegistrationForm.patchValue({
                firstName: user.data.data.firstname || '',
                lastName: user.data.data.lastname || '',
                // organization: user.data.data.additional_fields?.organization || ''
              });
              this.userDistricts = user.data.data.additional_fields?.district || [];
              ['firstName', 'lastName'].forEach(field => {
                const control = this.leaRegistrationForm.get(field);
                if (control?.invalid) {
                  control.markAsTouched();
                }
              });
            }
            this.loadDropdownData();
          }, () => {
            this.loadDropdownData();
          });
      } else {
        this.loadDropdownData();
      }
    });
}

  private async loadDropdownData() {
    forkJoin([
      this.httpService.get('/domain/lookup?requestType=DISTRICT'),
      this.httpService.get('/domain/lookup?requestType=MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=TOAST MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=GENERIC MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=PLACEHOLDER MESSAGES'),
      this.registrationService.getUserAgreementContent(500, '1', 'LEA'),
    ]).subscribe({
      next: (item: any) => {
        this.districtList = item[0].data.sort((a, b) => a.value.localeCompare(b.value));

        if (this.userDistricts.length > 0) {
          const validDistricts = this.userDistricts.filter(d =>
            this.districtList.some(dl => dl.key === d)
          );
          if (validDistricts.length > 0) {
            this.leaRegistrationForm.patchValue({ district: validDistricts });
            this.leaRegistrationForm.get('district')?.disable();
          }
        }


        this.errorMessages = item[1].data;
        this.toastMessages = item[2].data;
        this.genericMessages = item[3].data;
        this.placeholderMessages = item[4].data;
        // Process generic messages to make them easily accessible by key
        this.errorMessage = {};
        this.errorMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.errorMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('errorMessages', JSON.stringify(this.errorMessages));
        this.toastMessage = {};
        this.toastMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.toastMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('toastMessages', JSON.stringify(this.toastMessages));
        console.log(item);
        this.genericMessage = {};
        this.genericMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.genericMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('genericMessages', JSON.stringify(this.genericMessages));
        this.placeholderMessage = {};
        this.placeholderMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.placeholderMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('placeholderMessages', JSON.stringify(this.placeholderMessages));

        // Store user agreement content from lookup
        if (item[5]?.data?.length > 0) {
          const optionalData = item[5].data[0].optionaldata;
          if (optionalData) {
            try {
              const parsed = typeof optionalData === 'string' ? JSON.parse(optionalData) : optionalData;
              this.userAgreementContent = parsed?.content || '';
            } catch {
              this.userAgreementContent = optionalData;
            }
          }
        }

      },
      error: error => {
        console.error('Error loading dropdown data:', error);
      }
    });
  }
  createForm(user?: any) {
      this.leaRegistrationForm = this.fb.group({
        email: [this.emailFromUrl, ],
        firstName: [
          user?.firstname || '',
          [
            Validators.required,
            Validators.pattern("^[A-Za-z]+([-' ][A-Za-z]+)*\\s*$"),
            Validators.minLength(2),
            Validators.maxLength(30)
          ]
        ],
        lastName: [
          user?.lastname || '',
          [
            Validators.required,
            Validators.pattern("^[A-Za-z]+([-' ][A-Za-z]+)*\\s*$"),
            Validators.minLength(2),
            Validators.maxLength(30)
          ]
        ],
        // organization: [
        //   user?.organization || '',
        //   [
        //     Validators.required,
        //     Validators.pattern("^[A-Za-z][A-Za-z\\s.,\\-&'()\\/]*$"),
        //     Validators.minLength(2),
        //     Validators.maxLength(60)
        //   ]
        // ],
      department: [
        '',
        [
          Validators.pattern("^[A-Za-z][A-Za-z\\s.,\\-&'()\\/]*$"),
          Validators.minLength(2),
          Validators.maxLength(60)
        ]
      ],
         title: [
        '',
        [
          Validators.pattern("^[A-Za-z][A-Za-z\\s.,\\-&'()\\/]*$"),
          Validators.minLength(2),
          Validators.maxLength(60)
        ]
      ],
      district: [[], [this.districtRequired]],
      streetAddress: ['',
      [
          Validators.required,
          Validators.pattern("^[A-Za-z0-9][A-Za-z0-9\\s.,\\-'/#]*$"),
          Validators.minLength(3),
          Validators.maxLength(60)
      ]
      ],
      zipCode: ['',
        [
          Validators.required,
          Validators.pattern('^\\d{5}(|-\\d{4})$'),  // Either 5 digits or 5 digits followed by hyphen and 4 digits
          Validators.minLength(5),
          Validators.maxLength(10)
        ]
        ],
      city: ['', ],
      state: ['Nevada', ],
      phoneNumber: [
        '',
        [
          Validators.required,
          Validators.pattern('^(\\+1 )?\\(\\d{3}\\) \\d{3}-\\d{4}$'),
          Validators.maxLength(17)
        ]
      ],
        extension: [
        '',
        [Validators.pattern('^\\d{1,10}$'),
         Validators.minLength(2),
         Validators.maxLength(10)
      ]
    ],
      terms: [false, Validators.requiredTrue],
      consent:[false, Validators.requiredTrue]
    }, { validators: this.cityStateRequiredIfZipValid });
  }

  districtRequired(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value || (Array.isArray(value) && value.length === 0)) {
      return { required: true };
    }
    return null;
  }

  cityStateRequiredIfZipValid(form: FormGroup) {
  const zip = form.get('zipCode')?.value || '';
  const city = form.get('city')?.value || '';
  const state = form.get('state')?.value || '';
  const zipPattern = /^\d{5}$|^\d{5}-\d{4}$/;

  // If zip is valid but city or state is missing, return error
  if (zipPattern.test(zip) && (!city || !state)) {
    return { cityStateMissing: true };
  }
  return null;
}

  zipCodeFormat(event: any) {
    console.log("zipcode:🤳", event.target.value)
    let value = event.target.value.replace(/\D/g, '');
    if (value.length > 10) value = value.substring(0, 10);

    let formatted = value;

    // Check for invalid length - more than 5 but less than 9 digits
    if (value.length > 5 && value.length < 9) {
      this.leaRegistrationForm.get('zipCode')?.setErrors({ 'invalidZipLength': true });
    }

    if (value.length > 5) {
      formatted = ` ${value.substring(0, 5)}-${value.substring(5)}`;
    }

    if (value.length >= 5) {
      const allZerosPattern = /^0+$/;
      const isAllZeros = allZerosPattern.test(value);
      if (isAllZeros) {
        // Only force mask if not deleting
        const inputType = event.inputType || '';
        if (inputType !== 'deleteContentBackward' && inputType !== 'deleteContentForward') {
          let masked = value.length === 5 ? '00000' : '00000-0000';
          this.leaRegistrationForm.get('zipCode')?.setValue(masked, { emitEvent: false });
        }
        this.leaRegistrationForm.get('zipCode')?.setErrors({ 'allZeros': true });
        return;
      }
    }
    this.leaRegistrationForm.get('zipCode')?.setValue(formatted.trim(), { emitEvent: false });
          if (value.length < 5 || (value.length > 5 && value.length < 9)) {
    this.leaRegistrationForm.patchValue({
      city: '',
      state: ''
    });
  }

  // Only call getAddress if zip code is valid length
  if (value.length === 5 || value.length === 9) {
    setTimeout(() => {
      this.getAddress();
    }, 100);
  }
  }

  formatPhoneNumber(event: any) {
    let input = event.target.value;
    const isDeleting = event.inputType === 'deleteContentBackward';
    // Block alphabetic input
    if (/[a-zA-Z]/.test(input)) {
      input = input.replace(/[a-zA-Z]/g, '');
    }
    //Auto prepend +1 only when typing (not deleting)
    if (!isDeleting && !input.startsWith('+1') && input !== '+') {
      input = '+1 ' + input.replace(/^\+/, '');
    }
    // Allow empty value
    if (!input) {
      this.leaRegistrationForm.get('phoneNumber')?.setValue('', { emitEvent: false });
      return;
    }
    // If starts with '+1', enforce '+1 (XXX) XXX XXXX' format
    if (input.startsWith('+1')) {
      // Only insert space after '+1' if user is typing forward (not deleting)
      if (input.length > 2 && input[2] !== ' ') {
        if (event.inputType !== 'deleteContentBackward') {
          input = '+1 ' + input.slice(2);
        }
      }
      let numberPart = input.startsWith('+1 ') ? input.slice(3) : input.slice(2);
      let digits = numberPart.replace(/\D/g, '');
      // Strip repeated country code: e.g. user pasted 18XXXXXXXXX after field already had "+1 "
      if (digits.length === 11 && digits.startsWith('1')) {
        digits = digits.substring(1);
      }
      if (digits.length > 10) digits = digits.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      let finalValue = input.startsWith('+1 ') ? '+1 ' + formatted : '+1' + formatted;
      this.leaRegistrationForm.get('phoneNumber')?.setValue(finalValue, { emitEvent: false });
      return;
    }
    // If starts with '(', enforce '(XXX) XXX XXXX' format
    if (input.startsWith('(')) {
      let digits = input.replace(/\D/g, '');
      if (digits.length > 10) digits = digits.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      this.leaRegistrationForm.get('phoneNumber')?.setValue(formatted, { emitEvent: false });
      return;
    }
    // If only digits, format as '(XXX) XXX XXXX'
    if (/^\d+$/.test(input)) {
      let digits = input.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      this.leaRegistrationForm.get('phoneNumber')?.setValue(formatted, { emitEvent: false });
      return;
    }
    // Allow '+', '+1', '+1 ' as valid prefixes, and allow user to delete them
    if (input === '+' || input === '+1' || input === '+1 ') {
      this.leaRegistrationForm.get('phoneNumber')?.setValue(input, { emitEvent: false });
      return;
    }
    // For any other input, clear the field
    this.leaRegistrationForm.get('phoneNumber')?.setValue('', { emitEvent: false });
    return;
  }

  onSubmit() {
    if (this.leaRegistrationForm.valid) {
      const formData = {
        email: this.leaRegistrationForm.get('email')?.value,
        username :  this.leaRegistrationForm.get('email')?.value,
        password : 'Welcome@123',
        first_name: this.leaRegistrationForm.get('firstName')?.value,
        last_name: this.leaRegistrationForm.get('lastName')?.value,
        department: this.leaRegistrationForm.get('department')?.value,
        title: this.leaRegistrationForm.get('title')?.value,
        street_address: this.leaRegistrationForm.get('streetAddress')?.value,
        zipcode: this.leaRegistrationForm.get('zipCode')?.value,
        city: this.leaRegistrationForm.get('city')?.value,
        state: this.leaRegistrationForm.get('state')?.value,
        phone: this.leaRegistrationForm.get('phoneNumber')?.value.replace(/\D/g, '').replace(/^1(\d{10})$/, '$1'),
        extensions: this.leaRegistrationForm.get('extension')?.value,
        district: this.leaRegistrationForm.getRawValue().district || [],
        // organization: this.leaRegistrationForm.get('organization')?.value,
        is_channel: this.leaRegistrationForm.get('terms')?.value,
        is_consent: this.leaRegistrationForm.get('consent')?.value,
      };
      this.localstorage.setItem('externalRegistrationFormData', JSON.stringify(formData))
      this.registrationService
          .addExternalRegisterDetails(formData, 'lea')
          .pipe(
            take(1),
            takeUntil(this.destroy$),
            finalize(() => {
              // Ensures we stop loading regardless of success/error/early returns
              // this.isLoading = false;
            })
          )
          .subscribe({
            next: (response: any) => {
              this.alertService.success(
  `Your password has been set successfully.\nPlease log in with your new credentials to continue.`);
              setTimeout(() => {
                 this.router.navigate(['/login']);
              }, 5000);

               },
      error: (error) => {
        // Network/server errors or thrown errors
        const msg =
          error?.error?.message ||
          error?.message ||
          'Something went wrong while creating your account.';
        this.alertService.error(msg);
        console.error('Registration API error:', error);
      }
    });

    } else {
      this.leaRegistrationForm.markAllAsTouched();
      Object.keys(this.leaRegistrationForm.controls).forEach(key => {
        const control = this.leaRegistrationForm.get(key);
        if (control && control.invalid) {
          console.log(`Field ${key} is invalid:`, control.errors);
        }
      });
    }
  }

  goToLogin() {
    this.router.navigate(['']);
  }

  validateDate(control: any) {
    const selectedDate = new Date(control.value);
    const today = new Date();

    // Reset time part to compare just the dates
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);

    if (selectedDate > today) {
      return { 'futureDate': true };
    }

    return null;
  }
  get firstName() {
    return this.leaRegistrationForm.get('firstName');
  }
  get lastName() {
    return this.leaRegistrationForm.get('lastName');
  }
  // get organization() {
  //   return this.leaRegistrationForm.get('organization');
  // }
  get district() {
    return this.leaRegistrationForm.get('district');
  }
  get email() {
    return this.leaRegistrationForm.get('email');
  }
  get phoneNumber() {
    return this.leaRegistrationForm.get('phoneNumber');
  }
  get terms() {
    return this.leaRegistrationForm.get('terms');
  }
  get department() {
    return this.leaRegistrationForm.get('department');
  }
  get title() {
    return this.leaRegistrationForm.get('title');
  }
  get streetAddress() {
    return this.leaRegistrationForm.get('streetAddress');
  }
  get zipCode() {
    return this.leaRegistrationForm.get('zipCode');
  }
  get city() {
    return this.leaRegistrationForm.get('city');
  }
  get state() {
    return this.leaRegistrationForm.get('state');
  }
  get extension() {
    return this.leaRegistrationForm.get('extension');
  }
  open(content) {
    this.ngModal.open(content, { size: 'md', backdrop: 'static' }).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  getAddress(){
    const zipCodeControl = this.leaRegistrationForm.get('zipCode');
  const zipCodeValue = zipCodeControl?.value;

  // Check if zip code control has validation errors
  if (zipCodeControl?.invalid) {
    console.log('Zip code has validation errors, not fetching address:', zipCodeControl.errors);
    // Clear city and state if zip code is invalid
    this.leaRegistrationForm.patchValue({
      city: '',
      state: ''
    });
    return;
  }

   if (!zipCodeValue || zipCodeValue.trim() === '') {
    console.log('Zip code is empty');
    return;
  }

  const cleanZipCode = zipCodeValue.replace(/\D/g, '');
  if (cleanZipCode.length !== 5 && cleanZipCode.length !== 9) {
    console.log('Invalid zip code length:', cleanZipCode.length);
    this.leaRegistrationForm.patchValue({
      city: '',
      state: ''
    });
    return;
  }

   console.log('Calling smarty validation for valid zip code:', zipCodeValue);


     let input = {
      smartyInd: false,
      zipcode: this.leaRegistrationForm.get('zipCode')?.value
     }
      this.registrationService.smartyValidation(input).subscribe({
      next: response => {
        if(response.status === 'success'){
          if(response.data.length>0){
            console.log('smartyInd value:', input.smartyInd);
            console.log('Response data:', response.data[0].zipcodes[0]);

            // Handle different response structure based on smartyInd value
            const zipData = response.data[0].zipcodes[0];

            console.log('Selected city value:', );

            this.leaRegistrationForm.patchValue({
              city: zipData.default_city,
              state: zipData.state
            });
          }
        }
      }
    });
  }

  // duplicatePhoneNumber: boolean = false;
  // checkDuplicatePhoneNumber() {
  //   const phoneNumberRaw = this.leaRegistrationForm.get('phoneNumber')?.value;
  //   let phoneNumber = phoneNumberRaw && phoneNumberRaw.startsWith('+1')
  //     ? phoneNumberRaw.substring(2).replace(/\D/g, '')
  //     : phoneNumberRaw ? phoneNumberRaw.replace(/\D/g, '') : '';
  //   if (!phoneNumber) return;
  //   this.registrationService.checkLeaPhoneDuplicate(phoneNumber).subscribe({
  //     next: (result: any) => {
  //       this.duplicatePhoneNumber = result?.data.exists || false;
  //       if (this.duplicatePhoneNumber) {
  //         this.leaRegistrationForm.get('phoneNumber')?.setErrors({ ...this.leaRegistrationForm.get('phoneNumber')?.errors, duplicate: true });
  //       } else {
  //         const errors = this.leaRegistrationForm.get('phoneNumber')?.errors;
  //         if (errors) {
  //           delete errors['duplicate'];
  //           if (Object.keys(errors).length === 0) {
  //             this.leaRegistrationForm.get('phoneNumber')?.setErrors(null);
  //           } else {
  //             this.leaRegistrationForm.get('phoneNumber')?.setErrors(errors);
  //           }
  //         }
  //       }
  //     },
  //     error: () => {
  //       this.duplicatePhoneNumber = false;
  //     }
  //   });
  // }

 showConfirmRegModal(): void {
    this.showModal = true;
    // Remove auto navigation to /my-app. Navigation should happen only after login.
    // Optionally, you can close the modal after a timeout, but do not navigate.
    setTimeout(() => {
      this.router.navigate(['/login']);
    }, 2000);
    setTimeout(() => {
      this.closeModal();
    }, 6000);
  }

  closeModal(): void {
    this.showModal = false;
  }

  getDistrictDisplayName(key: any): string {
    if (typeof key === 'object' && key?.value) return key.value;
    const found = this.districtList.find(d => d.key === key);
    return found?.value || key;
  }

  getRemainingDistrictNames(selectedItems: any[]): string {
    const names = selectedItems.slice(2).map(item => this.getDistrictDisplayName(item));
    return names.map(name => `<span class="district-tooltip-item">${name}</span>`).join('<br/>');
  }

  getRemainingDistrictTooltip(): string {
    const selected = this.leaRegistrationForm.getRawValue().district || [];
    const names = selected.slice(2).map(key => this.getDistrictDisplayName(key));
    return names.map(name => `<span class="district-tooltip-item">${name}</span>`).join('<br/>');
  }


  onDistrictMoreClick(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    if (!target) return;
    target.dispatchEvent(new MouseEvent('mouseleave', { bubbles: false }));
    setTimeout(() => {
      target.dispatchEvent(new MouseEvent('mouseenter', { bubbles: false }));
    }, 0);
  }

   openTermsAndConditionsModal(event: Event): void {
      event.preventDefault();
      event.stopPropagation();

      if (this.userAgreementContent) {
        this.showTermsAndConditionsModal();
        return;
      }

      
      this.registrationService.getUserAgreementContent(500, '1', 'LEA').subscribe({
        next: (response: any) => {
          if (response?.data?.length > 0) {
            const optionalData = response.data[0].optionaldata;
            if (optionalData) {
              try {
                const parsed = typeof optionalData === 'string' ? JSON.parse(optionalData) : optionalData;
                this.userAgreementContent = parsed?.content || '';
              } catch {
                this.userAgreementContent = optionalData;
              }
            }
          }
          this.showTermsAndConditionsModal();
        },
        error: err => {
          console.error('Error loading user agreement content:', err);
          this.showTermsAndConditionsModal();
        }
      });
    }

    private showTermsAndConditionsModal(): void {
      this.matDialog.open(ContentManagementModalComponent, {
        width: '900px',
        disableClose: true,
        data: {
          heading: modalHeading.useragreement,
          content: this.userAgreementContent,
          buttons: [{ text: modalButtonTitles.close, class: 'btn-outline-primary' }]
        }
      });
    }

    openPrivacyPolicyModal(event: Event): void {
      event.preventDefault();
      event.stopPropagation();

      const options: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        size: "lg"
      };

      this.customModal = this.ngModal.open(ModalComponent, options);

      const modalConfig: ModalConfig = {
        buttons: [
          { text: modalButtonTitles.close, code: 'N', btnOutline: true }
        ],
        heading: modalHeading.privacyPolicy,
        modalContent: modalContent.privacyPolicy,
        hasTemplate: true,
        scrollable: true
      };

      this.customModal.componentInstance.modalConfig = modalConfig;
    }

}
